import { extend } from 'flarum/common/extend';
import DiscussionList from 'flarum/forum/components/DiscussionList';

/**
 * 为帖子列表添加无限滚动功能
 * 当用户滚动到页面底部时自动加载下一页
 */
export default function addInfiniteScroll() {
  let scrollHandler: (() => void) | null = null;
  let isLoadingMore = false;

  extend(DiscussionList.prototype, 'oncreate', function (this: any, vnode: any) {
    const state = this.attrs.state;

    // 移除旧的滚动监听器（如果存在）
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
    }

    // 创建滚动处理函数
    scrollHandler = () => {
      // 如果正在加载或没有更多数据，不处理
      if (isLoadingMore || !state.hasNext() || state.isLoadingNext()) {
        return;
      }

      // 计算滚动位置
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 当滚动到距离底部 300px 时触发加载
      const threshold = 300;

      if (scrollTop + windowHeight >= documentHeight - threshold) {
        isLoadingMore = true;

        state.loadNext().then(() => {
          isLoadingMore = false;
        }).catch(() => {
          isLoadingMore = false;
        });
      }
    };

    // 添加滚动监听器
    window.addEventListener('scroll', scrollHandler, { passive: true });
  });

  extend(DiscussionList.prototype, 'onremove', function () {
    // 组件移除时清理滚动监听器
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }
    isLoadingMore = false;
  });
}
